import { ClientReferralProgramQuery } from './client-referral-program-query';
import { CreateClientReferralProgramMutation } from './create-client-referrals-program-mutation';
import { DeleteClientReferralProgramMutation } from './delete-client-referrals-program-mutation';
import { NotifyReferralProgramClientsMutation } from './notify-referrals-program-clients-mutation';
export var endpoints = {
    clientReferralProgramQuery: new ClientReferralProgramQuery(),
    createClientReferralProgramMutation: new CreateClientReferralProgramMutation(),
    deleteClientReferralProgramMutation: new DeleteClientReferralProgramMutation(),
    notifyReferralProgramClientsMutation: new NotifyReferralProgramClientsMutation(),
};
